import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invite",
  "use": "icon-invite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-invite\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M16 6v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6h16Zm-4.824 1.5-4.072 4.104-1.897-1.897-.707.707 2.604 2.604 4.779-4.811-.707-.707ZM15 1a1 1 0 0 1 1 1v3H0V2a1 1 0 0 1 1-1h14ZM3 2v2h1V2H3Zm9 0v2h1V2h-1Z\" fill=\"#236CFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol